import { sanitize } from '~/lib/dompurify';
import { renderGFM } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_gfm.js?vue3';

// Render GitLab-flavoured Markdown safely with a directive
export const gfm = (el, { value, oldValue }) => {
  if (oldValue === value) return;
  const fragment = sanitize(value, {
    RETURN_DOM_FRAGMENT: true,
  });
  el.textContent = '';
  el.appendChild(fragment);
  renderGFM(el);
};
